import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './economic-activity-status.reducer';

export const EconomicActivityStatusDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const economicActivityStatusEntity = useAppSelector(state => state.economicActivityStatus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="economicActivityStatusDetailsHeading">
          <Translate contentKey="apiLocationApp.economicActivityStatus.detail.title">EconomicActivityStatus</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.economicActivityStatus.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.economicActivityStatus.date">Date</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.economicActivityStatus.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.economicActivityStatus.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.economicActivityStatus.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="economicallyActiveTotal">
              <Translate contentKey="apiLocationApp.economicActivityStatus.economicallyActiveTotal">Economically Active Total</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.economicallyActiveTotal}</dd>
          <dt>
            <span id="inEmployment">
              <Translate contentKey="apiLocationApp.economicActivityStatus.inEmployment">In Employment</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.inEmployment}</dd>
          <dt>
            <span id="employeePartTime">
              <Translate contentKey="apiLocationApp.economicActivityStatus.employeePartTime">Employee Part Time</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.employeePartTime}</dd>
          <dt>
            <span id="employeeFullTime">
              <Translate contentKey="apiLocationApp.economicActivityStatus.employeeFullTime">Employee Full Time</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.employeeFullTime}</dd>
          <dt>
            <span id="selfEmployed">
              <Translate contentKey="apiLocationApp.economicActivityStatus.selfEmployed">Self Employed</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.selfEmployed}</dd>
          <dt>
            <span id="unemployed">
              <Translate contentKey="apiLocationApp.economicActivityStatus.unemployed">Unemployed</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.unemployed}</dd>
          <dt>
            <span id="economicallyInactiveTotal">
              <Translate contentKey="apiLocationApp.economicActivityStatus.economicallyInactiveTotal">
                Economically Inactive Total
              </Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.economicallyInactiveTotal}</dd>
          <dt>
            <span id="retired">
              <Translate contentKey="apiLocationApp.economicActivityStatus.retired">Retired</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.retired}</dd>
          <dt>
            <span id="student">
              <Translate contentKey="apiLocationApp.economicActivityStatus.student">Student</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.student}</dd>
          <dt>
            <span id="lookingAfterHomeFamily">
              <Translate contentKey="apiLocationApp.economicActivityStatus.lookingAfterHomeFamily">Looking After Home Family</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.lookingAfterHomeFamily}</dd>
          <dt>
            <span id="longTermSickDisabled">
              <Translate contentKey="apiLocationApp.economicActivityStatus.longTermSickDisabled">Long Term Sick Disabled</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.longTermSickDisabled}</dd>
          <dt>
            <span id="other">
              <Translate contentKey="apiLocationApp.economicActivityStatus.other">Other</Translate>
            </span>
          </dt>
          <dd>{economicActivityStatusEntity.other}</dd>
        </dl>
        <Button tag={Link} to="/economic-activity-status" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/economic-activity-status/${economicActivityStatusEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EconomicActivityStatusDetail;
